import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKey3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKey3"><Path fillRule="evenodd" clipRule="evenodd" d="M16.5 2C19.5376 2 22 4.46243 22 7.5C22 10.5376 19.5376 13 16.5 13C15.3423 13 14.2689 12.6412 13.3828 12.0303L10.1816 15.2314L12.3223 17.3711L8.52148 21.1719L6.38184 19.0322L4.20703 21.207L2.79297 19.793L11.9688 10.6162C11.3583 9.7303 11 8.65721 11 7.5C11 4.46243 13.4624 2 16.5 2ZM16.5 4C14.567 4 13 5.567 13 7.5C13 9.433 14.567 11 16.5 11C18.433 11 20 9.433 20 7.5C20 5.567 18.433 4 16.5 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKey3;
